// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketsMap_container__2UEbe","mapbox":"MarketsMap_mapbox__1q_ln","small":"MarketsMap_small__KEwt6"};